module.exports = __webpack_public_path__ + "img/TLT.b42d8e43.png";